import React from 'react';
import PropTypes from 'prop-types'

import '../css/filters.css'

class PositionFilter extends React.Component {

  static propTypes = {
    filterKey: PropTypes.string,
    filterPositions: PropTypes.func,
  }

  handleChange = (event) => {
    this.props.filterPositions(event.target.value, this.props.filterKey);
  }

  render() {
    return (
      <div>
        <select name='position-filter' onChange={this.handleChange} defaultValue={'default'} className='position-filter'>   
          <option value='default' disabled='disabled'>Filter by position</option>
          <option value=''>All</option>
          <option value='QB'>QB</option>
          <option value='RB'>RB</option>
          <option value='FB'>FB</option>
          <option value='WR'>WR</option>
          <option value='TE'>TE</option>
          <option value='OT'>OT</option>
          <option value='G/C'>G/C</option>
          <option value='DT'>DT</option>
          <option value='DE/OLB'>DE/OLB</option>
          <option value='LB'>LB</option>
          <option value='CB'>CB</option>
          <option value='S'>S</option>
      </select>

      </div>
    )
  }
}

export default PositionFilter;